const ApiName = 'https://api-r-office.tdtu.uz';

// const ApiName = 'http://192.168.17.138:8080' //abdulaziz

export {ApiName}
const ApiNameGrant = 'https://api-grant.tdtu.uz';

// const ApiNameGrant = 'http://192.168.16.138:8081' //abdulaziz

export {ApiNameGrant}